import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['input', 'results', 'result'];

  connect() {
    if (this.resultTarget.value.length > 0) {
      this.searchByValue()
    };

    this.inputTarget.addEventListener('keydown', () =>
      this.searchUserCompany()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchUserCompany()
    );

  }

  renderResults(results) {
    let result = [];
    for (const r of results) {
      result.push(`
        <a class="dropdown-item false" data-id="${r.type === 'User' ? 'user' : 'company'}-${r.id}"
        data-name="${r.fullName}"
        data-action="click->shared--user-company-search#changeValue">
          <span class="icon "><i class="fas fa-${r.type === 'User' ? 'user' : 'building'}"></i></span>
          ${r.fullName}
        </a>
      `);
    }

    if (results.length > 0) {
      this.inputTarget.closest('.dropdown').classList.add('is-active');
    } else {
      this.inputTarget.closest('.dropdown').classList.remove('is-active');
    };
    this.resultsTarget.innerHTML = result.join('');
  }

  changeValue(event) {
    const target = event.target;
    this.resultTarget.value = target.dataset.id;
    this.inputTarget.value = target.dataset.name;
    this.inputTarget.closest('.dropdown').classList.remove('is-active');
  }

  searchUserCompany() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value;
      const that = this;
      Rails.ajax({
        type: 'GET',
        url: `/office/search.json?query=${query}`,
        success: (data) => {
          if (data.length > 0) {
              that.renderResults(data);
          }
        },
        error: () => {
          alert('Ошибка при попытке найти клиента по вашему запросу');
        },
      });
    }, 400);
  }

  searchByValue() {
    const id = this.resultTarget.value;
    const that = this;
    Rails.ajax({
      type: 'GET',
      url: `/office/search_by_id.json?id=${id}`,
      success: (data) => {
        that.inputTarget.value = data.fullName;
      },
      error: () => {
        alert('Ошибка при попытке найти клиента по вашему запросу');
      },
    });
  }
}